import 'data/storage';
import { v4 as uuid } from 'uuid';
import { FlowViewModel } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/viewModels/FlowViewModel';
import { FlowConfigurationViewModel } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/viewModels/FlowConfigurationViewModel';
import { TrackEventActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/TrackEventActionSettings';
import { ActionType, Action } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/Action';
import { StateViewModel } from '../models/viewModels/StateViewModel';
import { BuilderFeatures } from '../BuilderFeatures';
import { GeneralSettingsConstants } from 'modules/application/detail/attendance/generalsettings/GeneralSettingsConstants';
import { DESK_ID_PREFIX, DESK_AUTOCLOSING_MIN_STATE_VERSION, DESK_IGNORE_CREATE_TICKET_USER_MESSAGE_MIN_STATE_VERSION, DESK_REDIRECT_OUT_OF_ATTENDANCE_TIME_MIN_STATE_VERSION, SURVEY_ID_PREFIX, } from './BuilderStateService';
import { TrackContactsJourneyActionSettings } from '../models/TrackContactsJourneyActionSettings';
import { UNDER_CONSTRUCTION_TESTING } from 'modules/navbar/subheader/SubheaderDetailController';
import { FlowType } from '../models/FlowType';
import { CURRENT_SUBFLOW_VERSION } from '../BuilderMigrateFlows';
import { LeavingFromDeskActionSettings } from '../models/LeavingFromDeskActionSettings';
import { SecretConfigurationViewModel } from '../models/viewModels/SecretConfigurationViewModel';
export const STATE_TRACK_NAME = 'builder:stateTrack';
export const FLOW_KEY = 'blip_portal:builder_working_flow';
export const FLOW_ID_KEY = 'blip_portal:builder_working_flow_id';
export const CONFIGURATION_KEY = 'blip_portal:builder_working_configuration';
export const GLOBAL_ACTIONS_KEY = 'blip_portal:builder_working_global_actions';
export const PUBLISHED_FLOW_KEY = 'blip_portal:builder_published_flow';
export const PUBLISHED_CONFIGURATION_KEY = 'blip_portal:builder_published_configuration';
export const PUBLISHED_GLOBAL_ACTIONS_KEY = 'blip_portal:builder_published_global_actions';
export const LATEST_PUBLICATIONS_KEY = 'blip_portal:builder_latestpublications';
export const LOCK_KEY = 'blip_portal:builder_lock';
export const MAX_PUBLICATIONS_HISTORY = 10;
export const DEFAULT_VARIABLES_NAMES = [
    'bucket.?',
    'resource.?',
    'application.identifier',
    'application.domain',
    'application.instance',
    'calendar.datetime',
    'calendar.date',
    'calendar.day',
    'calendar.month',
    'calendar.year',
    'calendar.time',
    'calendar.hour',
    'calendar.minute',
    'calendar.second',
    'calendar.unixTime',
    'calendar.unixTimeMilliseconds',
    'calendar.dayOfWeek',
    'calendar.tomorrow.datetime',
    'calendar.tomorrow.date',
    'calendar.tomorrow.day',
    'calendar.tomorrow.month',
    'calendar.tomorrow.year',
    'calendar.tomorrow.time',
    'calendar.tomorrow.hour',
    'calendar.tomorrow.minute',
    'calendar.tomorrow.second',
    'calendar.tomorrow.unixTime',
    'calendar.tomorrow.unixTimeMilliseconds',
    'calendar.tomorrow.dayOfWeek',
    'calendar.yesterday.datetime',
    'calendar.yesterday.date',
    'calendar.yesterday.day',
    'calendar.yesterday.month',
    'calendar.yesterday.year',
    'calendar.yesterday.time',
    'calendar.yesterday.hour',
    'calendar.yesterday.minute',
    'calendar.yesterday.second',
    'calendar.yesterday.unixTime',
    'calendar.yesterday.unixTimeMilliseconds',
    'calendar.yesterday.dayOfWeek',
    'config.?',
    'contact.identity',
    'contact.name',
    'contact.email',
    'contact.group',
    'contact.address',
    'contact.city',
    'contact.phoneNumber',
    'contact.photoUri',
    'contact.cellPhoneNumber',
    'contact.gender',
    'contact.timezone',
    'contact.culture',
    'contact.source',
    'contact.serialized',
    'contact.extras.?',
    'context.?',
    'input.content',
    'input.entity.?.id',
    'input.entity.?.name',
    'input.entity.?.value',
    'input.intent.id',
    'input.intent.name',
    'input.intent.score',
    'input.intent.answer',
    'input.length',
    'input.message',
    'input.message.id',
    'input.message.from',
    'input.message.fromidentity',
    'input.message.to',
    'input.message.toidentity',
    'input.type',
    'random.guid',
    'random.string',
    'random.integer',
    'state.id',
    'state.name',
    'state.previous.id',
    'state.previous.name',
    'tunnel.destination',
    'tunnel.identity',
    'tunnel.originator',
    'tunnel.owner',
];
const BUILDER_POSTMASTER = 'postmaster@builder.msging.net';
const BUILDER_SOURCE = 'BuilderSource';
const SOURCE_APPLICATION = 'BuilderApplication';
const SOURCE_BUCKET = 'Bucket';
const LIME_FLOW_TYPE = 'application/vnd.iris.builder.flow+json';
const LIME_GLOBAL_ACTIONS_TYPE = 'application/vnd.iris.builder.global-action+json';
export var LockImplementation;
(function (LockImplementation) {
    LockImplementation[LockImplementation["Old"] = 0] = "Old";
    LockImplementation[LockImplementation["New"] = 1] = "New";
})(LockImplementation || (LockImplementation = {}));
export class BuilderService {
    static $inject = ['PipelineLockService', 'BucketService', 'HostingService', 'BlipService', 'MessagingHubService', 'ConfigurationsService', 'PipelineSubflowService', 'AccountService2', 'SecretService'];
    constructor(PipelineLockService, BucketService, HostingService, BlipService, MessagingHubService, ConfigurationsService, PipelineSubflowService, AccountService2, SecretService) {
        this.PipelineLockService = PipelineLockService;
        this.BucketService = BucketService;
        this.HostingService = HostingService;
        this.BlipService = BlipService;
        this.MessagingHubService = MessagingHubService;
        this.ConfigurationsService = ConfigurationsService;
        this.PipelineSubflowService = PipelineSubflowService;
        this.AccountService2 = AccountService2;
        this.SecretService = SecretService;
        this.addKeyValueInActionExtras = (action, trackingVariables) => {
            if (action.type == ActionType.TrackEvent) {
                action.settings.extras = {
                    ...action.settings.extras,
                    ...trackingVariables,
                };
            }
            if (action.type == ActionType.SendMessage ||
                action.type == ActionType.SendRawMessage ||
                action.type == ActionType.SendMessageFromHttp) {
                action.settings.metadata = {
                    ...action.settings.metadata,
                    ...trackingVariables,
                };
            }
            return action;
        };
        this.checkFeatures();
    }
    async checkFeatures() {
        this.useBuilderApplicationEnabled = await BuilderFeatures.useBuilderApplicationEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await BuilderFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await BuilderFeatures.isUseConfigurationsDomainOnMiscOperationsSetEnabled();
        this.isAiAgentCreateBuilderBlockEnabled = await BuilderFeatures.isAiAgentCreateBuilderBlockEnabled();
    }
    async getApplicationTemplateAsync(application, template) {
        return await this.HostingService.getTemplateApplicationJson(application, template);
    }
    async insertAtLatestPublications(flow, configuration, globalActions, subflows, typeOfCompile) {
        // There's no need to inserAtLatest if it's an under construction version
        // When it is a under construction testing version it has been published
        // and inserted at Latest versions, it was a problem, our clients didn't
        // know what was a published and a under construction version.
        if (typeOfCompile === UNDER_CONSTRUCTION_TESTING) {
            return;
        }
        const latestPublications = await this.getLatestPublications();
        const account = await this.AccountService2.me();
        const author = account ? account.fullName : '';
        const authorIdentity = account ? decodeURIComponent(account.identity) : '';
        if (latestPublications.publications.length >= MAX_PUBLICATIONS_HISTORY) {
            latestPublications.publications = latestPublications.publications.slice(0, -1);
        }
        const index = latestPublications.lastInsertedIndex === MAX_PUBLICATIONS_HISTORY ? 1 : latestPublications.lastInsertedIndex + 1;
        latestPublications.publications = [{ title: undefined, description: undefined, authorIdentity, author, publishedAt: new Date(), index }, ...latestPublications.publications];
        latestPublications.lastInsertedIndex = index;
        return Promise.all([
            this.BucketService.set(LATEST_PUBLICATIONS_KEY, latestPublications),
            this.BucketService.set(`${LATEST_PUBLICATIONS_KEY}:${index}`, { flow, configuration, globalActions, subflows }),
        ]);
    }
    async updatePublicationByIndex(index, publication) {
        const latestPublications = await this.getLatestPublications();
        latestPublications.publications[index] = publication;
        await this.BucketService.set(LATEST_PUBLICATIONS_KEY, latestPublications);
    }
    async getLatestPublications() {
        // If not available, get from the server
        try {
            return await this.BucketService.get(LATEST_PUBLICATIONS_KEY);
        }
        catch (e) {
            // If is bucket empty, return an empty.
            if (e.code == 67) {
                return { lastInsertedIndex: MAX_PUBLICATIONS_HISTORY, isMoreOptionsActive: false, publications: [] };
            }
            else {
                throw e;
            }
        }
    }
    async getPublishedVersion(index) {
        return this.BucketService.get(`${LATEST_PUBLICATIONS_KEY}:${index}`);
    }
    async setFlow(flow) {
        //Set builder data on Bucket
        if (this.useBuilderApplicationEnabled) {
            return await this.MessagingHubService.sendCommand({
                method: 'set',
                to: BUILDER_POSTMASTER,
                uri: '/flow',
                type: LIME_FLOW_TYPE,
                resource: flow,
            });
        }
        else {
            return this.BucketService.set(FLOW_KEY, flow);
        }
    }
    setFlowId(flowId) {
        return this.BucketService.set(FLOW_ID_KEY, flowId, 'text/plain');
    }
    async getBuilderSource() {
        try {
            if (!this.builderSource) {
                const source = await this.ConfigurationsService.getSingle(BUILDER_POSTMASTER, undefined, BUILDER_SOURCE, this.isConfigurationsApplicationsDomainUsageGetEnabled);
                this.builderSource = source.BuilderSource;
            }
        }
        catch (e) {
            if (e.code == 67) {
                this.builderSource = SOURCE_BUCKET;
            }
            else {
                console.error(e);
                throw e;
            }
        }
    }
    async getFlow(application) {
        if (this.useBuilderApplicationEnabled == undefined) {
            await this.checkFeatures();
        }
        await this.getBuilderSource();
        if (this.useBuilderApplicationEnabled) {
            if (this.builderSource !== SOURCE_APPLICATION) {
                const flow = await this.migrateFlowFromBucket(application);
                this.ConfigurationsService.set(BUILDER_POSTMASTER, { BuilderSource: SOURCE_APPLICATION }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                return flow;
            }
            else {
                return await this.MessagingHubService.sendCommand({
                    method: 'get',
                    to: BUILDER_POSTMASTER,
                    uri: '/flow',
                });
            }
        }
        else {
            if (this.builderSource === SOURCE_APPLICATION) {
                const flow = await this.MessagingHubService.sendCommand({
                    method: 'get',
                    to: BUILDER_POSTMASTER,
                    uri: '/flow',
                });
                this.BucketService.set(FLOW_KEY, flow);
                this.ConfigurationsService.set(BUILDER_POSTMASTER, { BuilderSource: SOURCE_BUCKET }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                return flow;
            }
            else {
                return await this.getFlowFromBucketOrNew(application);
            }
        }
    }
    async migrateFlowFromBucket(application) {
        const flow = await this.getFlowFromBucketOrNew(application);
        await this.MessagingHubService.sendCommand({
            method: 'set',
            to: BUILDER_POSTMASTER,
            uri: '/flow',
            type: LIME_FLOW_TYPE,
            resource: flow,
        });
        return flow;
    }
    async getFlowFromBucketOrNew(application) {
        // If not available, get from the server
        try {
            return await this.BucketService.get(FLOW_KEY);
        }
        catch (e) {
            // If is bucket empty, create the view model using the published model.
            if (e.code == 67) {
                return FlowViewModel.create(application.applicationJson.settings.flow);
            }
            else {
                throw e;
            }
        }
    }
    async getPublishedFlow() {
        try {
            return await this.BucketService.get(PUBLISHED_FLOW_KEY);
        }
        catch (e) {
            if (e.code == 67) {
                return undefined;
            }
            else {
                throw e;
            }
        }
    }
    async getFlowId(application) {
        try {
            return await this.BucketService.get(FLOW_ID_KEY);
        }
        catch (e) {
            // If is bucket empty, get the id from the published model.
            if (e.code == 67) {
                return this.getPublishedFlowId(application);
            }
            else {
                throw e;
            }
        }
    }
    getPublishedFlowId(application) {
        return application.applicationJson.settings.flow.id;
    }
    async publishSubFlow(application, flowViewModel, flowConfigurationViewModel, flowId) {
        let flow = FlowViewModel.createModel(flowViewModel, flowConfigurationViewModel, flowId, CURRENT_SUBFLOW_VERSION);
        flow = await this.setUpFlow(flow, flowConfigurationViewModel, application, undefined);
        application.applicationJson.settings.flow = flow;
        const keyIdentity = await this.HostingService.getHostingIdentity(application, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled, this.isConfigurationsApplicationsDomainUsageGetEnabled);
        await this.PipelineSubflowService.publish(application.shortName, application.applicationJson, keyIdentity);
    }
    async publishFlow(flowViewModel, configuration, globalActions, application, flowId, typeOfCompile = undefined) {
        const flowModel = FlowViewModel.createModel(flowViewModel, configuration, flowId);
        const flow = await this.setUpFlow(flowModel, configuration, application, globalActions);
        const subflows = await this.PipelineSubflowService.getEditedSubflowsOfFlow(flowViewModel);
        await this.storeApplicationData(flow, flowViewModel, configuration, application, globalActions, subflows, typeOfCompile);
    }
    async setUpFlow(flowModel, configuration, application, globalActions) {
        if (!application.isSubflow) {
            const globalActionState = StateViewModel.createModel(globalActions);
            flowModel.inputActions = globalActionState.inputActions;
            flowModel.outputActions = globalActionState.outputActions;
            flowModel.type = FlowType.Flow;
        }
        else {
            flowModel.type = FlowType.Subflow;
        }
        await this.setStateActions(flowModel.states, configuration, application);
        this.handleDeskConfigurations(flowModel.states);
        return this.cleanKeysStartingWithDolar(flowModel);
    }
    async setStateActions(states, configuration, application) {
        const isTrackContactsJourneyEnabled = await BuilderFeatures.isTrackContactsJourneyEnabled();
        const trackingVariables = {
            '#stateName': '{{state.name}}',
            '#stateId': '{{state.id}}',
            '#messageId': '{{input.message@id}}',
            '#previousStateId': '{{state.previous.id}}',
            '#previousStateName': '{{state.previous.name}}',
        };
        states.forEach(state => {
            state.inputActions.forEach(input => {
                input = this.addKeyValueInActionExtras(input, trackingVariables);
            });
            state.outputActions.forEach(output => {
                output = this.addKeyValueInActionExtras(output, trackingVariables);
            });
            if (configuration[STATE_TRACK_NAME] == 'true') {
                this.appendAutoEventTrack(state, trackingVariables);
            }
            if (isTrackContactsJourneyEnabled) {
                this.appendContactsJourneyTrack(state, trackingVariables);
            }
        });
    }
    handleDeskConfigurations(states) {
        this.isAutomaticClosingOfTicketsAllowed = true;
        this.ignoreCreateTicketOnUserMessage = true;
        this.isSurveyPublished = false;
        for (const state of states) {
            if (state.id.startsWith(DESK_ID_PREFIX)) {
                const deskStateVersion = parseFloat(state.deskStateVersion) || 0;
                if (deskStateVersion < DESK_AUTOCLOSING_MIN_STATE_VERSION) {
                    this.isAutomaticClosingOfTicketsAllowed = false;
                }
                if (deskStateVersion < DESK_IGNORE_CREATE_TICKET_USER_MESSAGE_MIN_STATE_VERSION) {
                    this.ignoreCreateTicketOnUserMessage = false;
                }
                if (deskStateVersion >= DESK_REDIRECT_OUT_OF_ATTENDANCE_TIME_MIN_STATE_VERSION && states.filter(state => state.id.startsWith(SURVEY_ID_PREFIX)).length > 0) {
                    this.isSurveyPublished = true;
                }
            }
        }
    }
    cleanKeysStartingWithDolar(flowModel) {
        return JSON.parse(JSON.stringify(flowModel, (key, value) => (key.startsWith('$') ? undefined : value)));
    }
    appendAutoEventTrack(state, trackingVariables) {
        if (state.root) {
            state.outputActions = [this.createAutoEventTrackAction(state, {
                    '#stateName': state.name,
                    '#stateId': state.id,
                    '#messageId': '{{input.message@id}}',
                })]
                .concat(state.outputActions);
        }
        else {
            state.inputActions = [this.createAutoEventTrackAction(state, trackingVariables)]
                .concat(state.inputActions);
        }
    }
    createAutoEventTrackAction(s, trackingVariables) {
        return new Action({
            type: ActionType.TrackEvent,
            settings: new TrackEventActionSettings({
                category: 'flow',
                action: s.name,
                extras: {
                    stateId: s.id,
                    ...trackingVariables,
                },
            }),
        });
    }
    appendContactsJourneyTrack(state, contactsJourneyTrack) {
        if (state.root) {
            state.outputActions = [this.createContactsJourneyTrack({
                    '#stateName': state.name,
                    '#stateId': state.id,
                })].concat(state.outputActions);
        }
        else {
            state.inputActions = [this.createContactsJourneyTrack(contactsJourneyTrack)]
                .concat(state.inputActions);
        }
    }
    createContactsJourneyTrack(contactsJourneyTrack) {
        return new Action({
            type: ActionType.TrackContactsJourney,
            settings: new TrackContactsJourneyActionSettings({
                previousStateId: contactsJourneyTrack['#previousStateId'],
                previousStateName: contactsJourneyTrack['#previousStateName'],
                stateId: contactsJourneyTrack['#stateId'],
                stateName: contactsJourneyTrack['#stateName'],
            }),
        });
    }
    async storeApplicationData(flow, flowViewModel, configuration, application, globalActions, subflows, typeOfCompile) {
        await this.saveFlowIntoApplication(application, flow, typeOfCompile);
        await this.setBuilderDataOnBucket(flowViewModel, configuration, globalActions, subflows, typeOfCompile);
    }
    async saveFlowIntoApplication(application, flowModel, typeOfCompile) {
        application.applicationJson.settings.flow = flowModel;
        await this.HostingService.publish(application, application.template, application.applicationJson, typeOfCompile);
    }
    async setBuilderDataOnBucket(flow, configuration, globalActions, subflows, typeOfCompile) {
        await Promise.all([
            this.setFlow(flow),
            this.setFlowConfiguration(configuration),
            this.BucketService.set(PUBLISHED_FLOW_KEY, flow),
            this.BucketService.set(PUBLISHED_CONFIGURATION_KEY, configuration),
            this.BucketService.set(PUBLISHED_GLOBAL_ACTIONS_KEY, globalActions),
            this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                [GeneralSettingsConstants.AUTOMATIC_CLOSED_TICKET_ALLOWED]: this.isAutomaticClosingOfTicketsAllowed,
                [GeneralSettingsConstants.IGNORE_CREATE_TICKET_ON_USER_MESSAGE]: this.ignoreCreateTicketOnUserMessage,
                [GeneralSettingsConstants.ATTENDANCE_SATISFACTION_SURVEY_ENABLED]: this.isSurveyPublished,
            }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
            this.insertAtLatestPublications(flow, configuration, globalActions, subflows, typeOfCompile),
        ]);
    }
    async setSecretConfigurationOnVault(secretConfiguration) {
        const items = [];
        if (Object.keys(secretConfiguration).length > 0) {
            for (const key in secretConfiguration) {
                if (secretConfiguration.hasOwnProperty(key) && secretConfiguration[key] !== '') {
                    items.push({
                        id: key,
                        value: btoa(secretConfiguration[key]),
                    });
                }
            }
            if (items.length === 0) {
                return;
            }
        }
        const secrets = {
            total: items.length,
            itemType: 'application/vnd.iris.builder.secret+json',
            items: items,
        };
        await Promise.all([
            this.SecretService.set(secrets),
        ]);
    }
    async getFlowConfiguration() {
        try {
            return await this.BucketService.get(CONFIGURATION_KEY);
        }
        catch (e) {
            // If is bucket empty, create a default configuration
            if (e.code == 67) {
                return FlowConfigurationViewModel.createDefault();
            }
            else {
                console.error(e);
                throw e;
            }
        }
    }
    async getFlowSecretConfiguration() {
        try {
            const secretConfigurationKeys = await this.SecretService.get();
            const secretKeys = Object.assign({}, ...secretConfigurationKeys.items.map((x) => ({ [x]: '***' })));
            return secretKeys;
        }
        catch (e) {
            // If is secret is empty, create a default configuration
            if (e.code == 67) {
                return SecretConfigurationViewModel.createDefault();
            }
            else {
                console.error(e);
                throw e;
            }
        }
    }
    async getPublishedFlowConfiguration() {
        try {
            return await this.BucketService.get(PUBLISHED_CONFIGURATION_KEY);
        }
        catch (e) {
            if (e.code == 67) {
                return undefined;
            }
            else {
                console.error(e);
                throw e;
            }
        }
    }
    async isAutomaticTrackingPublished() {
        try {
            const publishedConfiguration = await this.BucketService.get(PUBLISHED_CONFIGURATION_KEY);
            return (publishedConfiguration[STATE_TRACK_NAME] || '').toLowerCase() === 'true';
        }
        catch (e) {
            if (e.code == 67) {
                return false;
            }
            else {
                console.error(e);
                throw e;
            }
        }
    }
    setFlowConfiguration(configuration) {
        return this.BucketService.set(CONFIGURATION_KEY, configuration);
    }
    /**
     * Gets the fake state that stores the flow global actions.
     */
    async getGlobalActionsState() {
        await this.getBuilderSource();
        if (this.useBuilderApplicationEnabled) {
            if (this.builderSource !== SOURCE_APPLICATION) {
                const globalActions = await this.migrateGlobalActionsFromBucket();
                this.ConfigurationsService.set(BUILDER_POSTMASTER, { BuilderSource: SOURCE_APPLICATION }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                return globalActions;
            }
            else {
                return await this.MessagingHubService.sendCommand({
                    method: 'get',
                    to: BUILDER_POSTMASTER,
                    uri: '/flow/global-actions',
                });
            }
        }
        else {
            if (this.builderSource === SOURCE_APPLICATION) {
                const globalActions = await this.MessagingHubService.sendCommand({
                    method: 'get',
                    to: BUILDER_POSTMASTER,
                    uri: '/flow/global-actions',
                });
                this.BucketService.set(GLOBAL_ACTIONS_KEY, globalActions);
                this.ConfigurationsService.set(BUILDER_POSTMASTER, { BuilderSource: SOURCE_BUCKET }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                return globalActions;
            }
            else {
                return await this.getGlobalActionsFromBucketOrNew();
            }
        }
    }
    async migrateGlobalActionsFromBucket() {
        const globalActions = await this.getGlobalActionsFromBucketOrNew();
        await this.MessagingHubService.sendCommand({
            method: 'set',
            to: BUILDER_POSTMASTER,
            uri: '/flow/global-actions',
            type: LIME_GLOBAL_ACTIONS_TYPE,
            resource: globalActions,
        });
        return globalActions;
    }
    async getGlobalActionsFromBucketOrNew() {
        // If not available, get from the server
        try {
            if (this.useBuilderApplicationEnabled) {
                try {
                    return await this.MessagingHubService.sendCommand({
                        method: 'get',
                        to: BUILDER_POSTMASTER,
                        uri: '/flow/global-actions',
                    });
                }
                catch (e) {
                    if (e.code == 67) {
                        const globalActions = await this.BucketService.get(GLOBAL_ACTIONS_KEY);
                        await this.MessagingHubService.sendCommand({
                            method: 'set',
                            to: BUILDER_POSTMASTER,
                            uri: '/flow/global-actions',
                            type: LIME_GLOBAL_ACTIONS_TYPE,
                            resource: globalActions,
                        });
                        return globalActions;
                    }
                    else {
                        console.error(e);
                        throw e;
                    }
                }
            }
            else {
                return await this.BucketService.get(GLOBAL_ACTIONS_KEY);
            }
        }
        catch (e) {
            if (e.code == 67) {
                return new StateViewModel({
                    id: 'global-actions',
                });
            }
            else {
                console.error(e);
                throw e;
            }
        }
    }
    /**
     * Stores the flow global actions.
     */
    async setGlobalActionsState(state) {
        if (this.useBuilderApplicationEnabled) {
            return await this.MessagingHubService.sendCommand({
                method: 'set',
                to: BUILDER_POSTMASTER,
                uri: '/flow/global-actions',
                type: LIME_GLOBAL_ACTIONS_TYPE,
                resource: state,
            });
        }
        else {
            return this.BucketService.set(GLOBAL_ACTIONS_KEY, state);
        }
    }
    async getLockNode(lockImpl, shortName) {
        // Get in the bucket the value of the flow lock key.
        // The handle is the node of the current session with write lock.
        try {
            const currentNode = lockImpl == LockImplementation.New
                ? await this.PipelineLockService.get(shortName)
                : await this.BucketService.get(LOCK_KEY);
            if (!currentNode) {
                return undefined;
            }
            if (currentNode == this.BlipService.localNode) {
                return currentNode;
            }
            try {
                // Ping the node to check if it is alive
                await this.BlipService.sendCommand({
                    id: uuid(),
                    to: currentNode,
                    method: 'get',
                    uri: '/ping',
                }, 10000);
                return currentNode;
            }
            catch (e) {
                // If the ping fails, indicates that the node is not online and the lock is invalid.
                return undefined;
            }
        }
        catch (e) {
            if (e.code == 67) {
                return undefined;
            }
            else {
                throw e;
            }
        }
    }
    async getOnLeavingFromDeskSettings() {
        let onLeavingFromDesk = new LeavingFromDeskActionSettings();
        try {
            const closeSetting = await this.ConfigurationsService.getSingle(BUILDER_POSTMASTER, undefined, GeneralSettingsConstants.CLOSE_TICKET_ON_LEAVING_FROM_DESK_SETTING, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            onLeavingFromDesk = JSON.parse(closeSetting?.DeskOnLeavingSettings);
        }
        catch (e) {
            console.error(e);
        }
        return onLeavingFromDesk;
    }
    validateTab(elementReferenceId, state) {
        const customActionsTabElement = document.getElementById(elementReferenceId);
        if (customActionsTabElement) {
            if (state.$invalidCustomActions) {
                customActionsTabElement.classList.add('invalid-background-tooltip');
            }
            else {
                customActionsTabElement.classList.remove('invalid-background-tooltip');
            }
        }
    }
    async tryLockFlow(lockImpl, shortName, expiration) {
        // Write a lock in a bucket key for the flow.
        const currentNode = await this.getLockNode(lockImpl, shortName);
        if (!currentNode ||
            currentNode == this.BlipService.localNode) {
            // Send a ping to the server only to ensure the connection
            await this.BlipService.sendCommand({
                id: uuid(),
                method: 'get',
                uri: '/ping',
            }, 10000);
            if (lockImpl == LockImplementation.New) {
                await this.PipelineLockService.set(shortName, this.BlipService.localNode);
            }
            else {
                await this.BucketService.set(LOCK_KEY, this.BlipService.localNode, 'text/plain', expiration);
            }
            return true;
        }
        else {
            return false;
        }
    }
    async releaseLock(lockImpl, shortName) {
        const currentNode = await this.getLockNode(lockImpl, shortName);
        if (!currentNode) {
            return;
        }
        if (currentNode == this.BlipService.localNode) {
            if (lockImpl == LockImplementation.New) {
                await this.PipelineLockService.delete(shortName, this.BlipService.localNode);
            }
            else {
                return await this.BucketService.delete(LOCK_KEY);
            }
        }
    }
    requestLock(ownerNode, force, timeout) {
        if (this.lockRequestPromise) {
            return this.lockRequestPromise;
        }
        // Create two promises: a promise for the actual request and other for the timeout.
        const timeoutPromise = new Promise((resolve) => {
            setTimeout(() => {
                this.lockRequestPromise = undefined;
                resolve(false);
            }, timeout);
        });
        let resolveFunc;
        const messagePromise = new Promise((resolve) => {
            resolveFunc = resolve;
        });
        this.lockRequestPromise = Promise.race([messagePromise, timeoutPromise]);
        // Register a listener for waiting for the response
        if (this.lockResponseMessageListenerRegistration) {
            this.lockResponseMessageListenerRegistration();
        }
        this.lockResponseMessageListenerRegistration = this.BlipService.addMessageReceiver(async (message) => {
            this.lockResponseMessageListenerRegistration();
            this.lockRequestPromise = undefined;
            resolveFunc(message.content.released);
        }, (message) => message.type == 'application/vnd.blip.flow-lock-response+json');
        // Send a message asking for the lock
        this.BlipService.sendMessage({
            id: uuid(),
            to: ownerNode,
            type: 'application/vnd.blip.flow-lock-request+json',
            content: {
                force: force,
                timeout: timeout,
            },
        });
        return this.lockRequestPromise;
    }
    registerLockRequestListener(lockImpl, shortName, listener) {
        // Add a listener in the blip client for lock request from other users.
        return this.lockRequestMessageListenerRegistration = this.BlipService.addMessageReceiver(async (message) => {
            const lockResponseMessage = {
                id: uuid(),
                to: message.from,
                type: 'application/vnd.blip.flow-lock-response+json',
                content: {
                    released: false,
                },
            };
            // Call the provided listener
            if (await listener(message.from, message.content.force, message.content.timeout)) {
                await this.releaseLock(lockImpl, shortName);
                lockResponseMessage.content.released = true;
                this.lockRequestMessageListenerRegistration();
            }
            await this.BlipService.sendMessage(lockResponseMessage);
        }, (message) => message.type == 'application/vnd.blip.flow-lock-request+json');
    }
}
BuilderService.$inject = ['PipelineLockService', 'BucketService', 'HostingService', 'BlipService', 'MessagingHubService', 'ConfigurationsService', 'PipelineSubflowService', 'AccountService2', 'SecretService'];
